// Copyright aptihealth, inc. 2019 All Rights Reserved

import React from "react";
import { isConversationReadOnly, CONVERSATION_READ_ONLY_TYPES } from "../../../../utils/chatUtils";
import PropTypes from "prop-types";
import images from "../../../../utils/images";
import { useSelector } from "react-redux";
import { Toggle } from "../../../../component-library";
import { api } from "../../../../APIRequests";
import { isAuthorized } from "../../../../redux/actions/auth";

export const ChatHeader = (props) => {
  const { channel, isMobile, showMenu, switchMobileView } = props;
  const profile = useSelector((state) => state.auth.profile);
  const isReadOnly = isConversationReadOnly(profile?.care_team_members, channel);
  const isProviderNoLongerOnCareTeamReadOnly =
    isReadOnly === CONVERSATION_READ_ONLY_TYPES.PROVIDER_NO_LONGER_ON_CARE_TEAM;
  const isUserPrescriber = isAuthorized("provider:prescribe");
  const otherMemberId = channel?.otherMembers?.length && channel?.otherMembers[0].userId;

  const onToggleRestrictPatientReplies = () => {
    const urlParams = { patientId: otherMemberId };
    const data = {
      patient_read_only_message_thread: !channel.otherMembers[0]?.isMuted,
      channel_url: channel.url,
    };
    api.provider.toggle_patient_read_only_message_thread({
      data,
      urlParams,
    });
  };

  return (
    <div className="Messages__Chat__Header">
      {isMobile && (
        <img
          src={images("./icons/back-arrow.svg")}
          onClick={switchMobileView}
          alt="back-arrow"
          className="back-arrow"
        />
      )}
      <div className="d-flex justify-content-between w-100">
        <div>
          <img src={channel.coverImage} alt="avatar" className="avatar" />
          <span>
            <b>
              {channel.otherMembers.map((user) => (
                <React.Fragment key={user.userId}>
                  {user.nickname}
                  {user?.metaData?.preferred_name && (
                    <span className="preferred-name">{` (${user.metaData.preferred_name})`}</span>
                  )}
                  {user?.metaData?.preferred_pronouns && (
                    <span className="preferred-pronouns">
                      {` ${user.metaData.preferred_pronouns}`}
                    </span>
                  )}
                </React.Fragment>
              ))}
            </b>
          </span>
        </div>
        <div className="d-flex">
          {isUserPrescriber && (
            <div className="d-flex align-items-center">
              {channel.otherMembers[0].isMuted ? (
                <div className="d-flex flex-column">
                  <span className="bold">Replies restricted</span>
                  <span className="fs-12">
                    The patient will still receive your messages but can’t reply.
                  </span>
                </div>
              ) : (
                <div className="d-flex flex-column">
                  <span className="bold">Replies enabled</span>
                  <span className="fs-12">The patient can reply to messages in this thread.</span>
                </div>
              )}
              <Toggle
                name="restrict_patient_replies_toggle"
                checked={channel.otherMembers[0].isMuted}
                onClick={onToggleRestrictPatientReplies}
                className="restrict-patient-replies-toggle"
                testId="chat-header-restrict-patient-replies-toggle"
              />
            </div>
          )}
          {!isProviderNoLongerOnCareTeamReadOnly && (
            <div style={{ marginRight: "10px", cursor: "pointer" }} className="align-self-center">
              <img
                role="button"
                onClick={showMenu}
                className="cursor"
                src={images("./icons/three-dots-menu.svg")}
                alt="three dots menu"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

ChatHeader.propTypes = {
  channel: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  showMenu: PropTypes.func.isRequired,
  switchMobileView: PropTypes.func.isRequired,
};
